



















































































import {Component, Vue, Provide, Inject, Prop, Watch} from 'vue-property-decorator';
import {AccelerometerWidget} from '@/views/dashboard/interfaces';
import AccelerometerSegmentDiagram from '@/components/widgets/AccelerometerSegmentDiagram.vue';
import AccelerometerWidgetBindForm from '@/components/widgets/base/bindForms/AccelerometerWidgetBindForm.vue';
import {AxisBindData, AxisBoundaries} from '@/components/widgets/base/bindForms/interfaces';
import AccelerometerAxisRow from '@/components/widgets/accelerometerWidget/AccelerometerAxisRow.vue';
import {formatUnit} from '@/utils/unitUtils';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {getMeasurementById} from '@/utils/moduleUtils';
import {addSignalSubscription} from '@/utils/socketUtils';
import {uuidv4} from '@/utils/uuidUtils';

@Component({
  components: {
    AccelerometerSegmentDiagram,
    AccelerometerWidgetBindForm,
    AccelerometerAxisRow,
  },
})
export default class AccelerometerWidgetComponent extends Vue {
  // Виджет (передается извне)
  @Provide()
  @Inject()
  widget!: AccelerometerWidget;

  @Inject()
  measurements!: MeasurementData[];

  id!: string;

  //Сокет оси X
  xSubscriptionId!: string;
  xCurrentValue: number | null = null;
  xTrend = '';
  xBoundaries: AxisBoundaries = {
    warningBoundary: undefined,
    errorBoundary: undefined,
    dangerBoundary: undefined,
  };
  xUnit = '';

  //Сокет оси Y
  ySubscriptionId!: string;
  yCurrentValue: number | null = null;
  yTrend = '';
  yBoundaries: AxisBoundaries = {
    warningBoundary: undefined,
    errorBoundary: undefined,
    dangerBoundary: undefined,
  };
  yUnit = '';

  //Сокет оси Z
  zSubscriptionId!: string;
  zCurrentValue: number | null = null;
  zTrend = '';
  zBoundaries: AxisBoundaries = {
    warningBoundary: undefined,
    errorBoundary: undefined,
    dangerBoundary: undefined,
  };
  zUnit = '';

  //Число знаков для округления
  viewRoundingAccuracy = 2;

  //Ключ для перерисовки при изенении размера (извне)
  resizedKey = 0;

  // Цвет заголовка
  colorCaption = '#e5e5e5';

  //Число колонок
  @Prop({required: false})
  colNum!: number;

  @Watch('colNum')
  onAmountColChanged() {
    this.resizedKey++;
  }

  // Получить описание оси с максимальным значением
  get maxAxisDescription() {
    if (!this.maxAxis || !this.maxAxis.axis.measurement) return {name: '', shortName: ''};
    return {
      name: this.maxAxis.axis.measurement.name,
      shortName: this.maxAxis.axis.measurement.shortName,
      nameSensor: this.maxAxis.axis.pmodule?.name,
      shortNameSensor: this.maxAxis.axis.pmodule?.name,
    };
  }

  // Получить значение оси с максимальным значением
  get maxAxisValue() {
    if (!this.maxAxis || this.maxAxis.value == null) return 'н/д';
    let val = this.maxAxis.value;
    if (this.maxAxis.value > 10000) val = this.maxAxis.value / 1000;
    return `${val.toFixed(this.viewRoundingAccuracy)}`;
  }

  get maxAxisUnit() {
    if (!this.maxAxis || this.maxAxis.unit == null) return null;
    const unit = this.maxAxis.unit != '-' ? this.maxAxis.unit : '';
    if (this.maxAxis.value && this.maxAxis.value > 10000) return `тыс. ${unit}`;
    return `${unit}`;
  }

  // Получить тренд для оси с максимальным значением
  get maxAxisTrend() {
    if (!this.maxAxis || this.maxAxis.trend == null) return '';
    return this.maxAxis.trend;
  }

  // Получить ось с максимальным значением
  get maxAxis() {
    let axisList = [
      {value: this.xCurrentValue, unit: this.xUnit, axis: this.widget.xAxis, trend: this.xTrend},
      {value: this.yCurrentValue, unit: this.yUnit, axis: this.widget.yAxis, trend: this.yTrend},
      {value: this.zCurrentValue, unit: this.zUnit, axis: this.widget.zAxis, trend: this.zTrend},
    ];
    axisList = axisList.filter((x: any) => x.value != null);
    if (!axisList.length) return null;
    const maxAxis = axisList.reduce((prev: any, current: any) => {
      return prev.value > current.value ? prev : current;
    });

    return maxAxis;
  }

  mounted() {
    //хак для обновления диаграммы, после того как станут известны размеры виджета
    this.$nextTick(() => {
      this.resizedKey++;
    });
  }

  //Обработчик сокета
  onMessage(axis: AxisBindData, returnValueAlias: string, e: {data: string}) {
    const measurement =
      axis.measurementId !== undefined
        ? getMeasurementById(this.measurements, axis.measurementId)
        : null;
    if (!measurement) return;
    const strParse = JSON.parse(e.data);
    if (strParse) {
      const {
        value,
        module_identifier,
        module_alias,
        event_type,
      }: {
        value: number;
        module_identifier: string;
        module_alias: string;
        event_type: string;
      } = strParse;

      if (
        module_identifier !== axis.moduleGUID ||
        module_alias !== measurement.alias ||
        event_type !== measurement.eventType
      ) {
        return;
      }

      switch (returnValueAlias) {
        case 'x':
          if (this.xCurrentValue === null) {
            this.xTrend = '';
          } else {
            this.xTrend = value > this.xCurrentValue ? 'up' : 'down';
          }
          this.xCurrentValue = value;
          break;
        case 'y':
          if (this.yCurrentValue === null) {
            this.yTrend = '';
          } else {
            this.yTrend = value > this.yCurrentValue ? 'up' : 'down';
          }
          this.yCurrentValue = value;
          break;
        case 'z':
          if (this.zCurrentValue === null) {
            this.zTrend = '';
          } else {
            this.zTrend = value > this.zCurrentValue ? 'up' : 'down';
          }
          this.zCurrentValue = value;
      }
    }
  }

  // Обработчик привязки оси X
  onXAxisBind(data: AxisBindData) {
    this.widget.xAxis = {...data};
    this.subscribeXAxis(this.widget.xAxis);
  }

  // Обработчик привязки оси Y
  onYAxisBind(data: AxisBindData) {
    this.widget.yAxis = {...data};
    this.subscribeYAxis(this.widget.yAxis);
  }

  // Обработчик привязки оси Z
  onZAxisBind(data: AxisBindData) {
    this.widget.zAxis = {...data};
    this.subscribeZAxis(this.widget.zAxis);
  }

  // Подписка на сокет оси
  subscribeXAxis(axis: AxisBindData) {
    if (!axis.moduleGUID || !axis.moduleType || !axis.measurementId) return;
    const measurement = getMeasurementById(this.measurements, axis.measurementId);
    if (!measurement) return;
    const unit = formatUnit(measurement.unit, true);
    this.xUnit = unit != '-' ? unit : '';
    const id = `${this.id}+X+${axis.moduleGUID}+${measurement.alias}+${measurement.eventType}`;

    //переподключаемся, для этого удаляем старую подписку, делаем новую.
    this.$dataSocketManager.removeSubscription(this.xSubscriptionId);

    const params = {
      moduleType: axis.moduleType,
      moduleGUID: axis.moduleGUID,
      alias: measurement.alias,
      eventType: measurement.eventType,
    };
    const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
    const subscriptionFunction = (socket: WebSocket) =>
      addSignalSubscription.call(this, socket, params);

    this.$dataSocketManager.addSubscription(
      id,
      subscrName,
      subscriptionFunction,
      this.onMessage.bind(this, axis, 'x'),
    );

    this.xCurrentValue = null;
    this.xTrend = '';
    if (axis.boundaries) this.xBoundaries = axis.boundaries;
    this.xSubscriptionId = id;
  }

  subscribeYAxis(axis: AxisBindData) {
    if (!axis.moduleGUID || !axis.moduleType || !axis.measurementId) return;
    const measurement = getMeasurementById(this.measurements, axis.measurementId);
    if (!measurement) return;
    const unit = formatUnit(measurement.unit, true);
    this.yUnit = unit != '-' ? unit : '';
    const id = `${this.id}+Y+${axis.moduleGUID}+${measurement.alias}+${measurement.eventType}`;

    //переподключаемся, для этого удаляем старую подписку, делаем новую.
    this.$dataSocketManager.removeSubscription(this.ySubscriptionId);
    const params = {
      moduleType: axis.moduleType,
      moduleGUID: axis.moduleGUID,
      alias: measurement.alias,
      eventType: measurement.eventType,
    };
    const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;

    const subscriptionFunction = (socket: WebSocket) =>
      addSignalSubscription.call(this, socket, params);

    this.$dataSocketManager.addSubscription(
      id,
      subscrName,
      subscriptionFunction,
      this.onMessage.bind(this, axis, 'y'),
    );

    this.yCurrentValue = null;
    this.yTrend = '';
    if (axis.boundaries) this.yBoundaries = axis.boundaries;
    this.ySubscriptionId = id;
  }

  subscribeZAxis(axis: AxisBindData) {
    if (!axis.moduleGUID || !axis.moduleType || !axis.measurementId) return;
    const measurement = getMeasurementById(this.measurements, axis.measurementId);
    if (!measurement) return;
    const unit = formatUnit(measurement.unit, true);
    this.zUnit = unit != '-' ? unit : '';
    const id = `${this.id}+Z+${axis.moduleGUID}+${measurement.alias}+${measurement.eventType}`;

    //переподключаемся, для этого удаляем старую подписку, делаем новую.
    this.$dataSocketManager.removeSubscription(this.zSubscriptionId);

    const params = {
      moduleType: axis.moduleType,
      moduleGUID: axis.moduleGUID,
      alias: measurement.alias,
      eventType: measurement.eventType,
    };
    const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
    const subscriptionFunction = (socket: WebSocket) =>
      addSignalSubscription.call(this, socket, params);

    this.$dataSocketManager.addSubscription(
      id,
      subscrName,
      subscriptionFunction,
      this.onMessage.bind(this, axis, 'z'),
    );

    this.zCurrentValue = null;
    this.zTrend = '';
    if (axis.boundaries) this.zBoundaries = axis.boundaries;
    this.zSubscriptionId = id;
  }

  async created() {
    if (!this.widget) return;
    this.id = uuidv4();

    const axes = [
      {axis: this.widget.xAxis, returnValueAlias: 'x'},
      {axis: this.widget.yAxis, returnValueAlias: 'y'},
      {axis: this.widget.zAxis, returnValueAlias: 'z'},
    ];
    axes
      .filter((sa: any) => sa.axis)
      .forEach((sa: any) => {
        if (sa.returnValueAlias === 'x') this.subscribeXAxis(sa.axis);
        if (sa.returnValueAlias === 'y') this.subscribeYAxis(sa.axis);
        if (sa.returnValueAlias === 'z') this.subscribeZAxis(sa.axis);
      });
  }

  beforeDestroy() {
    this.$dataSocketManager.removeSubscription(this.xSubscriptionId);
    this.$dataSocketManager.removeSubscription(this.ySubscriptionId);
    this.$dataSocketManager.removeSubscription(this.zSubscriptionId);
  }
}
